import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface BannerGoodsDeal {
	dealEdTm: string;
	dealGoodsPrice: number;
	dealRervCnt: number;
	dealType: string;
	limitRervCnt: number;
	price: number;
}

/** ```
 * 상품 배너 가져오기
 *   `/goods/banner/deal`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const key = "useBannerGoodsDeal";
const getPath = (): string | null => `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/goods/banner/deal`;

/** ```
 * 상품 배너 가져오기
 *   `/goods/banner/deal`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const useBannerGoodsDeal = (goodsCd: string, options?: Partial<UseQueryOptions<Response<BannerGoodsDeal>, Error>>) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () => useConfigureAxios({url: getPath(), params: {goodsCd}}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		...options,
	});

export default useBannerGoodsDeal;
export {getPath, key};
export type {BannerGoodsDeal};
